import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./index.css";
import "./styles/layout.css";
import "./styles/table.css";
import "./styles/form.css";
import "./styles/badge.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
